module.exports = __webpack_public_path__ + "img/justify.38f657cd.svg";